export const COLORS = {
  primary: "#004E96",
  secondary: "#e02826",
  white: "#FFFFFF",
  black: "#000000",
  borderColor: "#D5E4F2",
  mainContainerBg: "#e9edf0",
  grayBackground: "#f8fcff",
  tableheader: "#F9FCFF",
  tableHeaderText: "#233E76",
  lightBlue: "#f4f9ff",
  selectedCard: "#f0f7ff",
};
